<div
  class="flex flex-col sm:flex-row sm:items-center justify-between bg-white border border-gray-200 hover:border-[var(--primary)] p-5 rounded-2xl transition-all duration-300 mb-4"
>
  <!-- Product Info -->
  <div class="flex items-center gap-4 flex-1">
    <img
      [src]="item.images[0] || '/placeholder.svg'"
      (error)="onImageError($event)"
      [alt]="item.product.name || 'Product Image'"
      class="aspect-square w-24 h-24 sm:w-28 sm:h-28 object-cover rounded-xl border border-gray-200 bg-gray-50"
    />
    <div class="flex flex-col gap-1">
      <!-- Gift Box Link -->
      <h3 *ngIf="item.product.id && (item.product.id.startsWith('gift-box') || item.viewsState?.boxStyle); else customOrStandard"
        [routerLink]="['/gifts']"
        [queryParams]="{ cartItemId: item.id }"
        class="font-bold text-gray-900 text-base sm:text-lg hover:text-[var(--primary)] transition-colors cursor-pointer leading-snug">
        {{ item.product.name || 'Custom Gift Box' }}
      </h3>

      <ng-template #customOrStandard>
        <!-- Custom Studio Design Link -->
        <h3 *ngIf="item.product.id && item.product.id.startsWith('custom'); else standardLink"
          [routerLink]="['/designs']"
          [queryParams]="{ cartItemId: item.id }"
          class="font-bold text-gray-900 text-base sm:text-lg hover:text-[var(--primary)] transition-colors cursor-pointer leading-snug">
          {{ item.product.name }}
        </h3>
        <!-- Standard Store Product Link -->
        <ng-template #standardLink>
          <h3 [routerLink]="['/products', item.product.id]"
            [queryParams]="{ color: item.color.name, size: item.size, quantity: item.quantity }"
            class="font-bold text-gray-900 text-base sm:text-lg hover:text-[var(--primary)] transition-colors cursor-pointer leading-snug">
            {{ item.product.name }}
          </h3>
        </ng-template>
      </ng-template>
      <p class="text-sm font-extrabold text-[var(--primary)]">
        Rs. {{ item.price | number : "1.2-2" }}
      </p>
      
      <div class="flex items-center gap-2 mt-1">
        @if (item.size) {
          <span class="text-xs font-semibold px-2.5 py-0.5 rounded-full bg-gray-100 border border-gray-200 text-gray-700">Size: {{ item.size }}</span>
        }
        <div
          [style.backgroundColor]="item.color.code"
          class="w-5 h-5 rounded-full border border-gray-300"
          [title]="item.color.name"
        ></div>
      </div>

      <button
        (click)="onRemove()"
        class="text-rose-600 text-xs font-semibold cursor-pointer hover:bg-rose-50 border border-rose-200 px-3 py-1 rounded-lg w-fit mt-2 transition-colors flex items-center gap-1"
      >
        Remove
      </button>
    </div>
  </div>

  <!-- Quantity + Price -->
  <div
    class="flex items-center justify-between sm:justify-end gap-6 mt-4 sm:mt-0"
  >
    <!-- Quantity Controls -->
    <div class="flex items-center border border-gray-300 rounded-xl overflow-hidden bg-gray-50">
      <button
        type="button"
        (click)="onDecrease()"
        class="px-3 py-1.5 cursor-pointer hover:bg-gray-200 text-gray-700 transition-colors"
      >
        <fa-icon [icon]="faMinus"></fa-icon>
      </button>
      <span class="px-4 py-1.5 text-gray-900 font-bold text-sm bg-white border-x border-gray-300">{{
        item.quantity
      }}</span>
      <button
        type="button"
        (click)="onIncrease()"
        class="px-3 py-1.5 cursor-pointer hover:bg-gray-200 text-gray-700 transition-colors"
      >
        <fa-icon [icon]="faPlus"></fa-icon>
      </button>
    </div>

    <!-- Total -->
    <div class="text-lg font-bold text-gray-900 min-w-[90px] text-right">
      Rs. {{ item.price * item.quantity | number : "1.2-2" }}
    </div>
  </div>
</div>
